<template>
  <div
    class="input-group"
    :class="`input-group-${variant} ${getStatus(error, success)}`"
  >
    <label :for="id" :class="variant === 'static' ? '' : 'form-label'">{{ label }}</label>
    <Field
      :id="id"
      :type="type"
      class="form-control"
      :class="getClasses(size)"
      :name="name"
      :model-value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      v-bind="$attrs"
      @update:model-value="(val) => $emit('update:modelValue', val)"
      @blur="$emit('blur', $event)"
      @input="$emit('input', $event)"
    />
  </div>
  <ErrorMessage :name="name" class="text-xs text-danger mt-1" as="div"></ErrorMessage>
</template>

<script>
import setMaterialInput from "@/assets/js/material-input.js";
import { Field, ErrorMessage } from "vee-validate";

export default {
  name: "MaterialInputField",
  components: {
    Field,
    ErrorMessage,
  },
  inheritAttrs: false,
  props: {
    variant: {
      type: String,
      default: "outline",
    },
    label: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "default",
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'blur', 'input'],
  mounted() {
    setMaterialInput();
  },
  methods: {
    getClasses: (size) => {
      let sizeValue;
      sizeValue = size ? `form-control-${size}` : null;
      return sizeValue;
    },
    getStatus: (error, success) => {
      let isValidValue;
      if (success) {
        isValidValue = "is-valid";
      } else if (error) {
        isValidValue = "is-invalid";
      } else {
        isValidValue = null;
      }
      return isValidValue;
    },
  },
};
</script>